import { render, staticRenderFns } from "./EditGrade.vue?vue&type=template&id=44ab44b4&scoped=true"
import script from "./EditGrade.vue?vue&type=script&lang=js"
export * from "./EditGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ab44b4",
  null
  
)

export default component.exports